import { render, staticRenderFns } from "./BaseButtonItemList.vue?vue&type=template&id=057d0f8e&"
import script from "./BaseButtonItemList.vue?vue&type=script&lang=js&"
export * from "./BaseButtonItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports